var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterUploadEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.61389H3C2.46957 5.61389 1.96086 5.82461 1.58579 6.19968C1.21071 6.57475 1 7.08346 1 7.61389V16.6139C1 17.1443 1.21071 17.653 1.58579 18.0281C1.96086 18.4032 2.46957 18.6139 3 18.6139H12C12.5304 18.6139 13.0391 18.4032 13.4142 18.0281C13.7893 17.653 14 17.1443 14 16.6139V15.6139",
    stroke: "#032A4B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.61351L16 6.61351M17.385 5.19851C17.7788 4.80466 18.0001 4.27049 18.0001 3.71351C18.0001 3.15653 17.7788 2.62236 17.385 2.22851C16.9912 1.83466 16.457 1.6134 15.9 1.6134C15.343 1.6134 14.8088 1.83466 14.415 2.22851L6 10.6135V13.6135H9L17.385 5.19851Z",
    stroke: "#032A4B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterUploadEdit);
export default __webpack_public_path__ + "static/media/register-upload-edit.6431d5f00182f1b7a3bfb78914876621.svg";
export { ForwardRef as ReactComponent };